<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/mecanico"> Cadastro/Mecanico </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="6">
            <v-text-field
              label="Nome *"
              v-model="nome"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'O Nome é obrigatória']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="cargoSelected"
              :items="filteredCargo"
              label="Cargo"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'O Cargo é obrigatório']"
              required
              :readonly="isAllowed"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/mecanico" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarMecanicoAsync } from "../../../services/mecanicoService";
import { mapState } from "vuex";

export default {
  name: "criarMecanico",
  data: () => ({
    overlay: false,
    valid: true,
    nome: null,
    active_tab: 2,
    cargoSelected: null,
  }),
  computed: {
    ...mapState("mecanico", ["mecanicos"]),
    ...mapState("cargo", ["cargos"]),
    filteredCargo() {
      return this.cargos.filter((c) => {
        return c.ativo === true;
      });
    },
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarMecanicoAsync(this.nome, this.cargoSelected.id);
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/mecanico");
        }
      }
    },
  },
};
</script>
